import React, { createContext, useContext } from "react";

import { Notification } from "@/types";
import { useNotifications } from "@/hooks"

interface NotificationState {
  notifications: Notification[];
  refresh: () => Promise<void>;
  markAsRead: (id: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  loading: boolean;
}

const NotificationContext = createContext<NotificationState>({
  notifications: [],
  refresh: async () => {},
  markAsRead: async (id: string) => {},
  markAllAsRead: async () => {},
  loading: false
});

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
   children,
}) => {

  const notifications = useNotifications();

  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useCompareContext must be used within a CompareProvider"
    );
  }
  return context;
};
